import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  padding-top: 64px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  @media (max-width: 1280px) and (min-width: 1024px) {
    max-width: calc(100% - 38px);
  }
  @media (max-width: 1023px) {
    padding: 88px 16px 96px 16px;
  }
`;
